var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLt = function SvgLt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    transform: "scale(.64143 .96773)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1063,
    height: 708.66,
    fill: "#007308",
    rx: 0,
    ry: 0,
    transform: "scale(.93865 .69686)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1063,
    height: 236.22,
    y: 475.56,
    fill: "#bf0000",
    rx: 0,
    ry: 0,
    transform: "scale(.93865 .69686)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb300",
    d: "M0 0h997.77v164.61H0z"
  }))));
};
export default SvgLt;